import PastVisitsCollection from 'models/Provider/PastVisitsCollection'
import User from 'singletons/User'
import groupBy from 'lodash/groupBy'
import { isToday } from 'date-fns/isToday'
import { isYesterday } from 'date-fns/isYesterday'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'
import Placeholder from 'components/Dashboard/common/Placeholder'
import VisitCard from 'components/Dashboard/cards/VisitCard'

type PastVisitsListProps = { list: PastVisitsCollection['list']; header?: ReactNode }

const PastVisitsList = ({ list, header }: PastVisitsListProps) => {
  const groupsByDate = groupBy(list || [], ({ scheduledAt }) => {
    if (isToday(new Date(scheduledAt))) {
      return 'Today'
    }

    if (isYesterday(new Date(scheduledAt))) {
      return 'Yesterday'
    }

    return 'All Visits'
  })

  const sectionsData = Object.keys(groupsByDate).map((title) => ({ title, data: groupsByDate[title] }))

  return (
    <div className="flex flex-col gap-8 max-w-[998px] 2xl:max-w-[1200px] w-full mx-auto px-6 mt-10">
      {sectionsData?.length ? (
        sectionsData.map(({ title, data }, index) => (
          <div className="flex flex-col gap-4" key={title}>
            <div className="flex justify-between items-center gap-x-4 gap-y-2 flex-wrap">
              <h4 className="uppercase typography-body font-semibold text-neutral-800">{title}</h4>
              {!index && (header || null)}
            </div>
            {data.map((pastVisit) => (
              <VisitCard
                key={pastVisit.pendingVisitId}
                memberMode
                visit={pastVisit}
                editable={User.providerId === pastVisit.providerId}
              />
            ))}
          </div>
        ))
      ) : (
        <>
          {header || null}
          <Placeholder text="No visits found." icon="visits" />
        </>
      )}
    </div>
  )
}

export default observer(PastVisitsList)
